// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var toB4ParseError = {
    toB4: function (v) {
        return Data_LogicValues_B4.Undecidable.value;
    }
};
var toB4Error = {
    toB4: function (v) {
        return Data_LogicValues_B4.Undecidable.value;
    }
};
var toB4Boolean = {
    toB4: function (v) {
        if (v) {
            return Data_LogicValues_B4.Yes.value;
        };
        if (!v) {
            return Data_LogicValues_B4.No.value;
        };
        throw new Error("Failed pattern match at Data.LogicValues.ToB4 (line 38, column 1 - line 40, column 18): " + [ v.constructor.name ]);
    }
};
var toB4B4$prime = {
    toB4: function (v) {
        if (v instanceof Data_LogicValues_B4["Indeterminate$prime"]) {
            return Data_LogicValues_B4.Indeterminate.value;
        };
        if (v instanceof Data_LogicValues_B4["Undecidable$prime"]) {
            return Data_LogicValues_B4.Undecidable.value;
        };
        throw new Error("Failed pattern match at Data.LogicValues.ToB4 (line 34, column 1 - line 36, column 36): " + [ v.constructor.name ]);
    }
};
var toB4B4 = {
    toB4: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var toB4 = function (dict) {
    return dict.toB4;
};
var toB41 = /* #__PURE__ */ toB4(toB4Boolean);
var toB42 = /* #__PURE__ */ toB4(toB4B4$prime);
var toB4Either = function (dictToB4) {
    var toB43 = toB4(dictToB4);
    return function (dictToB41) {
        return {
            toB4: Data_Either.either(toB43)(toB4(dictToB41))
        };
    };
};
var toB4Maybe = function (dictToB4) {
    return {
        toB4: Data_Maybe.maybe(Data_LogicValues_B4.Indeterminate.value)(toB4(dictToB4))
    };
};
var toValB4 = function (dictToB4) {
    return lmap(toB4(dictToB4));
};
var splitClassical = function (dictToB4) {
    var toB43 = toB4(dictToB4);
    return function (x) {
        var v = toB43(x);
        if (v instanceof Data_LogicValues_B4.Yes) {
            return new Data_Either.Left(true);
        };
        if (v instanceof Data_LogicValues_B4.No) {
            return new Data_Either.Left(false);
        };
        if (v instanceof Data_LogicValues_B4.Indeterminate) {
            return new Data_Either.Right(Data_LogicValues_B4["Indeterminate$prime"].value);
        };
        if (v instanceof Data_LogicValues_B4.Undecidable) {
            return new Data_Either.Right(Data_LogicValues_B4["Undecidable$prime"].value);
        };
        throw new Error("Failed pattern match at Data.LogicValues.ToB4 (line 50, column 20 - line 54, column 40): " + [ v.constructor.name ]);
    };
};
var splitClassicalVal = function (dictToB4) {
    var splitClassical1 = splitClassical(dictToB4);
    return function (v) {
        var v1 = lmap(splitClassical1)(v);
        if (v1 instanceof Data_Either.Left && v1.value0 instanceof Data_Either.Left) {
            return new Data_Either.Left(v1.value0.value0);
        };
        if (v1 instanceof Data_Either.Left && v1.value0 instanceof Data_Either.Right) {
            return new Data_Either.Right(new Data_Either.Left(v1.value0.value0));
        };
        if (v1 instanceof Data_Either.Right) {
            return new Data_Either.Right(new Data_Either.Right(v1.value0));
        };
        throw new Error("Failed pattern match at Data.LogicValues.ToB4 (line 60, column 23 - line 63, column 47): " + [ v1.constructor.name ]);
    };
};
var fromClassicalVal$prime = function (v) {
    if (v instanceof Data_Either.Left) {
        return new Data_Either.Left(toB41(v.value0));
    };
    if (v instanceof Data_Either.Right && v.value0 instanceof Data_Either.Left) {
        return new Data_Either.Left(toB42(v.value0.value0));
    };
    if (v instanceof Data_Either.Right && v.value0 instanceof Data_Either.Right) {
        return new Data_Either.Right(v.value0.value0);
    };
    throw new Error("Failed pattern match at Data.LogicValues.ToB4 (line 66, column 33 - line 69, column 37): " + [ v.constructor.name ]);
};
export {
    fromClassicalVal$prime,
    splitClassical,
    splitClassicalVal,
    toValB4,
    toB4,
    toB4B4,
    toB4Error,
    toB4ParseError,
    toB4B4$prime,
    toB4Boolean,
    toB4Either,
    toB4Maybe
};
//# sourceMappingURL=index.js.map
